var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return (_vm.notification.dataList && _vm.notification.dataList.length) ||
    !_vm.isEmpty
    ? _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c(
            "a-popover",
            {
              attrs: {
                placement: "bottomRight",
                overlayClassName:
                  "news-popover-overlay entry-head-drop-overlay",
                trigger: ["hover"],
                arrowPointAtCenter: "",
              },
            },
            [
              _c(
                "span",
                { staticClass: "right-content__action" },
                [
                  _c(
                    "a-badge",
                    {
                      attrs: {
                        count: _vm.notification.noReadCount,
                        "overflow-count": _vm.maxCount,
                        offset: [
                          (`${
                            _vm.notification.noReadCount > _vm.maxCount
                              ? _vm.maxCount + 1
                              : _vm.notification.noReadCount
                          }`.length -
                            1) *
                            2,
                          0,
                        ],
                        "number-style": {
                          height: "16px",
                          lineHeight: "16px",
                          fontSize: "12px",
                          padding: "0 5px",
                          boxShadow: "0 0 0 1px transparent",
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        { attrs: { href: "javascript:;" } },
                        [
                          _c("icon-font", {
                            staticClass: "icon",
                            attrs: { type: "gb-icon-lingdang" },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "news-menu",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [
                  _c("div", { staticClass: "news-menu-title" }, [
                    _c("span", [
                      _vm._v(_vm._s(_vm.langCodeLabels[_vm.currentLang].title)),
                    ]),
                    _c(
                      "span",
                      {
                        style: _vm.statusStyle,
                        on: { click: _vm.handleNotips },
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.langCodeLabels[_vm.currentLang].status)
                        ),
                      ]
                    ),
                  ]),
                  _vm.notification.dataList
                    ? _c(
                        "div",
                        _vm._l(
                          _vm.notification.dataList,
                          function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "news-menu-item",
                                on: {
                                  click: function ($event) {
                                    return _vm.toDetails(item)
                                  },
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "news-menu-item-top" },
                                  [
                                    _vm.msgTypeList[item.msgType]
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "news-menu-item-top__label",
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.msgTypeList[item.msgType][
                                                  _vm.langCodes[_vm.currentLang]
                                                ]
                                              )
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "news-menu-item-top__time",
                                      },
                                      [
                                        _c("a-icon", {
                                          staticStyle: {
                                            "margin-right": "3px",
                                            "font-size": "12px",
                                            color: "#444444",
                                          },
                                          attrs: { type: "clock-circle" },
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm
                                                .moment(
                                                  item.sendTime ||
                                                    item.createTime
                                                )
                                                .format("YYYY-MM-DD HH:mm:ss")
                                            ) +
                                            " "
                                        ),
                                      ],
                                      1
                                    ),
                                  ]
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "news-menu-item-info",
                                    attrs: { title: item.msgTitle },
                                  },
                                  [_vm._v(" " + _vm._s(item.msgTitle) + " ")]
                                ),
                              ]
                            )
                          }
                        ),
                        0
                      )
                    : _c("div", { staticClass: "empty-list" }, [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/interface _authorization_no-data.png"),
                            alt: "",
                          },
                        }),
                        _c("p", [_vm._v(_vm._s(_vm.$t("empty_data")))]),
                      ]),
                  _c(
                    "div",
                    { staticClass: "news-menu-more" },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: { "font-size": "12px" },
                          attrs: { type: "link" },
                          on: {
                            click: function ($event) {
                              return _vm.toDetails()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.langCodeLabels[_vm.currentLang].more) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _c(
            "span",
            {
              staticStyle: {
                display: "inline-flex",
                "max-width": "20px",
                opacity: "0",
              },
            },
            [_vm._v(_vm._s(_vm.notification.noReadCount))]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }